import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Modal,
  Form,
  DatePicker,
  TimePicker,
  Input,
  Select,
  Card
} from "antd";
import { PlusOutlined, CloseCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { ToastContainer, toast } from "react-toastify";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration); 

function MockInterviewInstructor() {

  const token = localStorage.getItem("token");

  const [availability, setAvailability] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const [slotModalOpen, setSlotModalOpen] = useState(false);
 

  const [selectedInterview, setSelectedInterview] = useState(null);

  const [editSlotModalOpen, setEditSlotModalOpen] = useState(false);
  const [deleteSlotModalOpen, setDeleteSlotModalOpen] = useState(false);

  const [selectedSlot, setSelectedSlot] = useState(null);
  const [openMonth, setOpenMonth] = useState(null);

  const [actionModalOpen, setActionModalOpen] = useState(false);

const [interviewLinkModalOpen, setInterviewLinkModalOpen] = useState(false);

const [feedbackModalOpenNew, setFeedbackModalOpenNew] = useState(false);

const [currentTime, setCurrentTime] = useState(dayjs());

const shownAlerts = React.useRef({});

const [statusModalOpen, setStatusModalOpen] = useState(false);
const [newStatus, setNewStatus] = useState("");
const [statusLoading, setStatusLoading] = useState(false);

const [openNoShowMonth, setOpenNoShowMonth] = useState(null);

  /* ===============================
     FETCH AVAILABILITY
  =============================== */

  const fetchAvailability = async () => {

    try {

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/mock-interview/instructor-availability-dates-for-instructor`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (res.data.success) {
        setAvailability(res.data.data);
      }

    } catch (err) {
      console.log(err);
    }

  };

  /* ===============================
     FETCH INTERVIEWS
  =============================== */

  const fetchInterviews = async () => {

    try {

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/mock-interview/get-instructor-interviews`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setInterviews(res.data.data);
      }

      setLoading(false);

    } catch (err) {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchAvailability();
    fetchInterviews();
  }, []);

  /* ===============================
     CREATE SLOT
  =============================== */

  const createAvailability = async (values) => {

    try {

     const res = await axios.post(
  `${process.env.REACT_APP_API_URL}/mock-interview/instructor-availability-dates`,
  {
    AvailableDate: values.date.format("YYYY-MM-DD"),
    AvailableTime: values.time.format("HH:mm:ss"),
    InterviewLink: values.interviewLink, 
  },
  { headers: { Authorization: `Bearer ${token}` } }
);

      if (res.data.success) {

        toast.success("Slot created successfully");

        setSlotModalOpen(false);
        fetchAvailability();

      }

    } catch (err) {

      toast.error("Failed to create slot");

    }

  };

  /* ===============================
     FEEDBACK
  =============================== */

  const submitFeedback = async (values) => {

    try {

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/mock-interview/update-interview-feedback`,
        {
          id: selectedInterview.id,
          InterviewResult: values.result,
          ProbabilityOfHiring: values.hiring,
          Score: values.score,
          TechnicalFeedback: values.feedback
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {

        toast.success("Interview feedback submitted");

        setFeedbackModalOpenNew(false);
        setActionModalOpen(false)
        fetchInterviews();

      }

    } catch (err) {

      toast.error("Failed to submit feedback");

    }

  };

  /* ===============================
     INTERVIEW TABLE
  =============================== */

  const columns = [

   {
  title: "Student Name",
  render: (row) => (
    <span className="font-semibold text-slate-800">
      {row.StudentName}
    </span>
  )
},

{
  title: "Course",
  render: (row) => (
    <span className="px-3 py-1 text-sm font-medium text-indigo-700 bg-indigo-100 rounded-md">
      {row.CourseName}
    </span>
  )
},

{
  title: "Date",
  render: (row) => (
    <span className="px-3 py-1 text-sm font-semibold text-blue-700 bg-blue-100 rounded-md">
      {dayjs(row.ScheduledDate).format("DD MMM YYYY")}
    </span>
  )
},
    {
  title: "Time",
  render: (row) => (
    <span className="px-3 py-1 text-sm font-semibold text-purple-700 bg-purple-100 rounded-lg">
      {dayjs(row.ScheduledTime, "HH:mm:ss").format("h:mm A")}
    </span>
  )
},

   {
  title: "Status",
  render: (row) => {

    let statusColor = "bg-blue-600";

    if (row.InterviewStatus === "COMPLETED") {
      statusColor = "bg-green-600";
    }

    if (row.InterviewStatus === "IN_PROGRESS") {
      statusColor = "bg-orange-500";
    }

    return ( 
      <button
        onClick={() => {
          setSelectedInterview(row);
          // setNewStatus(row.InterviewStatus);
          setStatusModalOpen(true);
        }}
        className={`px-4 py-1 text-sm font-semibold text-white rounded-lg ${statusColor} hover:opacity-90`}
      >
        {row.InterviewStatus}
      </button>
    );
  }
},

    {
  title: "Action",
  render: (row) => (
    <Button
      type="primary"
      className="font-semibold bg-red-600"
      onClick={() => {
        setSelectedInterview(row);
        setActionModalOpen(true);
      }}
    >
      Actions
    </Button>
  )
}

  ];

  const columnsNoShow = [

   {
  title: "Student Name",
  render: (row) => (
    <span className="font-semibold text-slate-800">
      {row.StudentName}
    </span>
  )
},

{
  title: "Course",
  render: (row) => (
    <span className="px-3 py-1 text-sm font-medium text-indigo-700 bg-indigo-100 rounded-md">
      {row.CourseName}
    </span>
  )
},

{
  title: "Date",
  render: (row) => (
    <span className="px-3 py-1 text-sm font-semibold text-blue-700 bg-blue-100 rounded-md">
      {dayjs(row.ScheduledDate).format("DD MMM YYYY")}
    </span>
  )
},
    {
  title: "Time",
  render: (row) => (
    <span className="px-3 py-1 text-sm font-semibold text-purple-700 bg-purple-100 rounded-lg">
      {dayjs(row.ScheduledTime, "HH:mm:ss").format("h:mm A")}
    </span>
  )
},

   {
  title: "Status",
  render: (row) => {

    let statusColor = "bg-blue-600";

    if (row.InterviewStatus === "COMPLETED") {
      statusColor = "bg-green-600";
    }

    if (row.InterviewStatus === "IN_PROGRESS") {
      statusColor = "bg-orange-500";
    }

    return (
      <span
        className={`px-4 py-1 text-sm font-semibold text-white rounded-lg ${statusColor}`}
      >
        {row.InterviewStatus}
      </span>
    );
  }
}

//     {
//   title: "Action",
//   render: (row) => (
//     <Button
//       type="primary"
//       className="font-semibold bg-red-600"
//       onClick={() => {
//         setSelectedInterview(row);
//         setActionModalOpen(true);
//       }}
//     >
//       Actions
//     </Button>
//   )
// }

  ];

  /* ===============================
     EDIT SLOT
  =============================== */

  const handleEditSlot = (row) => {
    setSelectedSlot(row);
    setEditSlotModalOpen(true);
  };

  const updateSlot = async (values) => {

    try {

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/mock-interview/update-slot`,
        {
          id: selectedSlot.id,
          AvailableTime: values.time.format("HH:mm:ss")
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (res.data.success) {

        toast.success("Slot updated successfully");

        setEditSlotModalOpen(false);

        fetchAvailability();

      }

    } catch (err) {

      toast.error("Failed to update slot");

    }

  };

  /* ===============================
     DELETE SLOT
  =============================== */

  const handleDeleteSlot = (row) => {
    setSelectedSlot(row);
    setDeleteSlotModalOpen(true);
  };

  const confirmDeleteSlot = async () => {

    try {

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/mock-interview/delete-slot`,
        {
          id: selectedSlot.id
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (res.data.success) {

        toast.success("Slot deleted successfully");

        setDeleteSlotModalOpen(false);

        fetchAvailability();

      }

    } catch (err) {

      toast.error("Failed to delete slot");

    }

  };

  /* ===============================
     GROUP BY MONTH
  =============================== */

  const availabilityByMonth = availability.reduce((acc, slot) => {

    const monthKey = dayjs(slot.AvailableDate).format("YYYY-MM");
    const monthLabel = dayjs(slot.AvailableDate).format("MMMM YYYY");

    if (!acc[monthKey]) {
      acc[monthKey] = {
        label: monthLabel,
        slots: []
      };
    }

    acc[monthKey].slots.push(slot);

    return acc;

  }, {});


  const updateInterviewLink = async (values) => {

  try {

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/mock-interview/update-interview-link`,
      {
        id: selectedInterview.id,
        MockInterviewLink: values.link
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (res.data.success) {

      toast.success("Interview link added successfully");

      setInterviewLinkModalOpen(false);
      setActionModalOpen(false)
      fetchInterviews();

    }

  } catch (err) {

    toast.error("Failed to update interview link");

  }

};

const liveInterviews = interviews.filter(
  (item) =>
    item.InterviewStatus === "SCHEDULED" ||
    item.InterviewStatus === "RESCHEDULED"
);

useEffect(() => {

  const interval = setInterval(() => {
    setCurrentTime(dayjs());
  }, 1000);

  return () => clearInterval(interval);

}, []);

const getInterviewCountdown = (item) => {

  const interviewDateTime = dayjs(
    `${item.ScheduledDate} ${item.ScheduledTime}`
  );

  const diff = interviewDateTime.diff(currentTime);

  if (diff <= 0) {
    return "Started";
  }

  const totalSeconds = Math.floor(diff / 1000);

  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${days}d ${hours}h ${minutes}m ${seconds}s`;

};

useEffect(() => {

  liveInterviews.forEach((item) => {

    const interviewDateTime = dayjs(
      `${item.ScheduledDate} ${item.ScheduledTime}`
    );

    const diffSeconds = interviewDateTime.diff(currentTime, "second");

    const twoMinuteKey = `${item.id}_2min`;
    const startKey = `${item.id}_start`;

    /* =========================
       2 Minute Warning
    ========================= */

    if (diffSeconds <= 120 && diffSeconds > 60 && !shownAlerts.current[twoMinuteKey]) {

      shownAlerts.current[twoMinuteKey] = true;

      Modal.warning({
        title: "Interview Starting Soon",
        content: `Mock interview with ${item.StudentName} will start in 2 minutes.`,
        okText: "OK"
      });

    }

    /* =========================
       Interview Time Reached
    ========================= */

    if (diffSeconds <= 0 && !shownAlerts.current[startKey]) {

      shownAlerts.current[startKey] = true;

      Modal.confirm({
        title: "Mock Interview Time Reached",
        content: `Interview with ${item.StudentName} is starting now.`,
        okText: "Join Now",
        cancelText: "Later",
        onOk: () => {
          if (item.MockInterviewLink) {
            window.open(item.MockInterviewLink, "_blank");
          }
        }
      });

    }

  });

}, [currentTime, liveInterviews]);

const activeInterviews = interviews.filter(
  (item) =>
    item.InterviewStatus === "SCHEDULED" 
);

const completedInterviews = interviews.filter(
  (item) => item.InterviewStatus === "COMPLETED"
);

const reScheduledInterviews = interviews.filter(
  (item) =>
    item.InterviewStatus === "RESCHEDULED" 
);

const noShowInterviews = interviews.filter(
  (item) =>
    item.InterviewStatus === "NO_SHOW" 
);


// DashBoards ????///////

const today = dayjs().format("YYYY-MM-DD");

const todayInterviews = interviews.filter(
  (item) => item.ScheduledDate === today
);



const scheduledCount = interviews.filter(
  (item) => item.InterviewStatus === "SCHEDULED"
).length;

const completedCount = interviews.filter(
  (item) => item.InterviewStatus === "COMPLETED"
).length;
const rescheduled = interviews.filter(
  (item) => item.InterviewStatus === "RESCHEDULED"
).length;

const noShow = interviews.filter(
  (item) => item.InterviewStatus === "NO_SHOW"
).length;


const handleUpdateStatus = async () => {
  if (!newStatus) {
    toast.error("Please select status");
    return;
  }

  // console.log(newStatus);
  
  try {
    setStatusLoading(true);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/mock-interview/update-status`,
      {
        id: selectedInterview.id,
        InterviewStatus: newStatus
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (res.data.success) {
      toast.success("Status updated");
      setStatusModalOpen(false);
       fetchInterviews();

    }

  } catch (err) {
    toast.error("Failed to update status");
  } finally {
    setStatusLoading(false);
  }
};

const noShowByMonth = noShowInterviews.reduce((acc, item) => {

  const monthKey = dayjs(item.ScheduledDate).format("YYYY-MM");
  const monthLabel = dayjs(item.ScheduledDate).format("MMMM YYYY");

  if (!acc[monthKey]) {
    acc[monthKey] = {
      label: monthLabel,
      data: []
    };
  }

  acc[monthKey].data.push(item);

  return acc;

}, {});

  return (

    <div className="p-10">

       <ToastContainer
                                          position="bottom-left"
                                          autoClose={5000}
                                          hideProgressBar={true}
                                          newestOnTop={false}
                                          closeOnClick
                                          rtl={false}
                                          pauseOnFocusLoss
                                          draggable
                                          pauseOnHover
                                          theme="dark"
                                          className="!mb-6 !ml-4"
                                          toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                                        />


      <div className="w-full py-5 mb-10 text-center bg-black rounded-lg shadow-md">

  <h1 className="text-2xl font-extrabold tracking-wide text-white uppercase">
    Mock Interview Instructor Panel
  </h1>

</div>

      <div className="flex items-center justify-between mb-10">

        <h1 className="text-xl font-bold text-slate-800">
          
        </h1>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          className="p-5 font-semibold "
          onClick={() => setSlotModalOpen(true)}
        >
          Add Availability Slot
        </Button>

      </div>


     <div className="grid grid-cols-1 gap-6 p-8 mb-10 rounded-lg md:grid-cols-2 xl:grid-cols-4 bg-slate-600">

<Card className="transition border-l-4 border-blue-500 shadow-sm bg-blue-50 hover:shadow-md">
<div className="flex items-center justify-between">
<div>
<p className="text-sm font-semibold text-blue-700">
Today's Interviews
</p>
<h2 className="mt-1 text-3xl font-bold text-blue-800">
{todayInterviews.length}
</h2>
</div>
<div className="text-3xl">
📅
</div>
</div>
</Card>



<Card className="transition border-l-4 border-blue-500 shadow-sm bg-blue-50 hover:shadow-md">
<div className="flex items-center justify-between">
<div>
<p className="text-sm font-semibold text-blue-700">
Scheduled
</p>
<h2 className="mt-1 text-3xl font-bold text-blue-800">
{scheduledCount}
</h2>
</div>
<div className="text-3xl">
⏳
</div>
</div>
</Card>

<Card className="transition border-l-4 border-blue-500 shadow-sm bg-red-50 hover:shadow-md rounded-2xl">
  <div className="flex items-center justify-between">
    
    <div>
      <p className="text-sm font-semibold tracking-wide text-blue-700">
        Rescheduled
      </p>
      <h2 className="mt-1 text-3xl font-bold text-blue-900">
        {rescheduled}
      </h2>
    </div>

    <div className="text-3xl">
      🔄
    </div>

  </div>
</Card>



<Card className="transition-all duration-200 bg-white border border-red-100 shadow-sm hover:shadow-md rounded-2xl">
  <div className="flex items-center justify-between">

    {/* LEFT CONTENT */}
    <div>
      <p className="text-sm font-semibold tracking-wide text-red-500 uppercase">
        No Show Interviews
      </p>

      <h2 className="mt-1 text-3xl font-bold text-slate-800">
        {noShow}
      </h2>
    </div>

    {/* RIGHT ICON */}
    <div className="flex items-center justify-center bg-red-100 rounded-full w-14 h-14">
      <CloseCircleOutlined className="text-2xl text-red-500" />
    </div>

  </div>
</Card>

<Card className="transition border-l-4 border-green-500 shadow-sm bg-green-50 hover:shadow-md">
<div className="flex items-center justify-between">
<div>
<p className="text-sm font-semibold text-green-700">
Completed
</p>
<h2 className="mt-1 text-3xl font-bold text-green-800">
{completedCount}
</h2>
</div>
<div className="text-3xl">
✅
</div>
</div>
</Card>

</div>

      {/* ===============================
         AVAILABILITY
      =============================== */}

      <Card
  title={
    <span className="text-xl font-extrabold text-slate-900">
      MY AVAILABLE SLOTS
    </span>
  }
  className="mb-10 bg-slate-200"
>

        <div className="space-y-6">

          {Object.keys(availabilityByMonth)
            .sort()
            .map((monthKey) => {

              const month = availabilityByMonth[monthKey];

              return (

                <div key={monthKey} className="bg-white border shadow-sm rounded-xl">

                  <div
                    onClick={() =>
                      setOpenMonth(openMonth === monthKey ? null : monthKey)
                    }
                    className="flex items-center justify-between p-5 cursor-pointer hover:bg-gray-50 "
                  >

                    <div className="text-lg font-semibold text-blue-700">
                      {month.label}
                    </div>

                    <div className="text-sm text-gray-500">
                      {month.slots.length} Slots
                    </div>

                  </div>

                  {openMonth === monthKey && (

                    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2 lg:grid-cols-4">

                      {month.slots.map((slot) => (

                        <div
                          key={slot.id}
                          className="p-4 transition-all duration-200 border rounded-lg shadow-sm hover:shadow-lg hover:-translate-y-1"
                        >

                          <div className="flex items-center justify-between mb-2">

                            <span className="font-semibold text-cyan-700">
                              {dayjs(slot.AvailableDate).format("DD MMM YYYY")}
                            </span>

                            <span
                              className={`px-3 py-1 text-xs font-semibold text-white rounded-md ${
                                slot.SlotStatus === "AVAILABLE"
                                  ? "bg-green-600"
                                  : "bg-red-600"
                              }`}
                            >
                              {slot.SlotStatus}
                            </span>

                          </div>

                          <div className="mb-3 text-gray-700">
                            🕒 {dayjs(slot.AvailableTime, "HH:mm:ss").format("hh:mm A")}
                          </div>

                          {slot.SlotStatus === "AVAILABLE" && (

                            <div className="flex gap-2">

                              <Button
                                type="primary"
                                size="small"
                                onClick={() => handleEditSlot(slot)}
                              >
                                Edit
                              </Button>

                              <Button
                                danger
                                size="small"
                                onClick={() => handleDeleteSlot(slot)}
                              >
                                Delete
                              </Button>

                            </div>

                          )}

                        </div>

                      ))}

                    </div>

                  )}

                </div>

              );

            })}

        </div>

      </Card>

      <Card title={
    <span className="text-xl font-extrabold text-slate-900">
      TODAY'S MOCK INTERVIEWS
    </span>
  }
   className="mb-10 bg-blue-100">

{liveInterviews.length === 0 && (

<div className="py-10 text-center text-gray-500">
No interviews currently in progress
</div>

)}

<div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">

{liveInterviews.map((item) => {

const countdown = getInterviewCountdown(item);

return (

<div
key={item.id}
className="p-6 transition-all bg-white border shadow-sm rounded-xl hover:shadow-lg"
>

<div className="flex items-center justify-between mb-4">

<h3 className="text-lg font-bold text-slate-800">
{item.StudentName}
</h3>

<span className="px-3 py-1 text-xs font-semibold text-white bg-green-600 rounded-lg">
LIVE
</span>

</div>

<div className="mb-3 space-y-1 text-sm text-gray-600">

<p>
<b>Course:</b> {item.CourseName}
</p>

<p>
<b>Batch:</b> {item.BatchName} ({item.BatchType})
</p>

<p>
<b>Date:</b> {dayjs(item.ScheduledDate).format("DD MMM YYYY")}
</p>

<p>
<b>Time:</b>{" "}
{dayjs(item.ScheduledTime, "HH:mm:ss").format("hh:mm A")}
</p>

<p className="font-semibold text-orange-600">
⏳ Starts In: {getInterviewCountdown(item)}
</p>

</div>

<div className="mt-4">

<Button
type="primary"
block
className="font-semibold bg-purple-600"
onClick={() => window.open(item.MockInterviewLink, "_blank")}
>
Join Now
</Button>

</div>

</div>

);

})}

</div>

</Card>

      {/* ===============================
         INTERVIEWS IN_PROGRESS AND SCHEDULED
      =============================== */}

     <Card  title={
    <span className="text-xl font-extrabold text-slate-900">
      UPCOMING MOCK INTERVIEWS
    </span>
  }
   className="mb-10 bg-red-100">

<Table
rowKey="id"
loading={loading}
columns={columns}
dataSource={activeInterviews}
/>

</Card>

<Card  title={
    <span className="text-xl font-extrabold text-slate-900">
      RESCHEDULED MOCK INTERVIEWS
    </span>
  }
   className="mb-10 bg-orange-100">

<Table
rowKey="id"
loading={loading}
columns={columns}
dataSource={reScheduledInterviews}
/>

</Card>

<Card
  title={
    <span className="text-xl font-extrabold text-white">
      NO_SHOW MOCK INTERVIEWS
    </span>
  }
  className="mb-10 bg-red-500"
>

  <div className="space-y-6">

    {Object.keys(noShowByMonth).length === 0 && (
      <div className="py-10 text-center text-white">
        No NO_SHOW interviews found
      </div>
    )}

    {Object.keys(noShowByMonth)
      .sort()
      .map((monthKey) => {

        const month = noShowByMonth[monthKey];

        return (

          <div
            key={monthKey}
            className="overflow-hidden transition bg-white shadow-md rounded-xl"
          >

            {/* HEADER */}
            <div
              onClick={() =>
                setOpenNoShowMonth(
                  openNoShowMonth === monthKey ? null : monthKey
                )
              }
              className="flex items-center justify-between p-5 bg-red-100 cursor-pointer hover:bg-red-200"
            >

              <div className="text-lg font-bold text-red-700">
                {month.label}
              </div>

              <div className="text-sm font-semibold text-red-600">
                {month.data.length} Interviews
              </div>

            </div>

            {/* TABLE */}
            {openNoShowMonth === monthKey && (

              <div className="p-5">

                <Table
                  rowKey="id"
                  loading={loading}
                  columns={columnsNoShow}
                  dataSource={month.data}
                  pagination={{ pageSize: 5 }}
                />

              </div>

            )}

          </div>

        );

      })}

  </div>

</Card>


      {/* ===============================
         INTERVIEWS COMPLETED
      =============================== */}

<Card  title={
    <span className="text-xl font-extrabold text-slate-900">
      COMPLETED MOCK INTERVIEWS
    </span>
  }
   className="mb-10 bg-green-100">

<Table
rowKey="id"
loading={loading}
columns={columns}
dataSource={completedInterviews}
/>

</Card>



<Modal
  open={slotModalOpen}
  footer={null}
  title={
    <div className="text-xl font-bold text-slate-800">
      Add Availability Slot
    </div>
  }
  onCancel={() => setSlotModalOpen(false)}
  centered
>
  <Form layout="vertical" onFinish={createAvailability} className="mt-3">

    {/* DATE */}
    <Form.Item
      label={<span className="font-semibold text-slate-700">Date</span>}
      name="date"
      rules={[{ required: true, message: "Please select date" }]}
    >
      <DatePicker className="w-full rounded-lg h-11 border-slate-300" />
    </Form.Item>

    {/* TIME */}
    <Form.Item
      label={<span className="font-semibold text-slate-700">Time</span>}
      name="time"
      rules={[{ required: true, message: "Please select time" }]}
    >
      <TimePicker
        className="w-full rounded-lg h-11 border-slate-300"
        format="hh:mm A"
      />
    </Form.Item>

    {/* INTERVIEW LINK */}
    <Form.Item
      label={<span className="font-semibold text-slate-700">Interview Link</span>}
      name="interviewLink"
      rules={[
        { required: true, message: "Please enter interview link" },
        { type: "url", message: "Enter a valid URL (https://...)" },
      ]}
    >
      <Input
        placeholder="https://meet.google.com/xyz-abcd-123"
        className="w-full rounded-lg h-11 border-slate-300 focus:border-purple-500"
      />
    </Form.Item>

    {/* SUBMIT */}
    <Button
      htmlType="submit"
      type="primary"
      block
      className="h-12 mt-2 text-base font-semibold text-white border-none shadow-md rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600"
    >
      ➕ Create Slot
    </Button>

  </Form>
</Modal>

      {/* EDIT SLOT MODAL */}

     <Modal
  open={editSlotModalOpen}
  title={
    <div className="text-xl font-bold text-slate-800">
      Edit Slot Time
    </div>
  }
  footer={null}
  onCancel={() => setEditSlotModalOpen(false)}
  centered
>

{selectedSlot && (

<Form layout="vertical" onFinish={updateSlot} className="mt-3">

  {/* INFO CARD */}
  <div className="p-4 mb-4 border shadow-sm bg-slate-50 rounded-xl border-slate-200">

    <p className="text-sm text-slate-600">Date</p>
    <p className="font-semibold text-slate-800">
      {dayjs(selectedSlot.AvailableDate).format("DD-MM-YYYY")}
    </p>

    <p className="mt-2 text-sm text-slate-600">Current Time</p>
    <p className="font-semibold text-blue-600">
      {dayjs(selectedSlot.AvailableTime, "HH:mm:ss").format("hh:mm A")}
    </p>

  </div>

  {/* TIME PICKER */}
  <Form.Item
    label={<span className="font-semibold text-slate-700">New Time</span>}
    name="time"
    rules={[{ required: true, message: "Please select new time" }]}
  >
    <TimePicker
      className="w-full rounded-lg h-11 border-slate-300 focus:border-blue-500"
      format="hh:mm A"
    />
  </Form.Item>

  {/* SUBMIT BUTTON */}
  <Button
    type="primary"
    htmlType="submit"
    block
    className="h-12 mt-2 text-base font-semibold text-white transition-all duration-200 border-none shadow-md rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700"
  >
    ⏱️ Update Slot
  </Button>

</Form>

)}

</Modal>

<Modal
  open={deleteSlotModalOpen}
  title={
    <div className="text-xl font-bold text-red-600">
      Delete Slot
    </div>
  }
  onCancel={() => setDeleteSlotModalOpen(false)}
  onOk={confirmDeleteSlot}
  okText="Delete"
  centered
  okButtonProps={{
    danger: true,
    className:
      "h-10 px-6 font-semibold rounded-lg shadow-md bg-gradient-to-r from-red-500 to-rose-600 border-none",
  }}
>

{selectedSlot && (

  <div className="p-4 mt-2 border border-red-200 shadow-sm bg-red-50 rounded-xl">

    <p className="text-slate-700">
      Are you sure you want to delete this slot?
    </p>

    <div className="mt-3 font-semibold text-red-700">
      {dayjs(selectedSlot.AvailableDate).format("DD-MM-YYYY")} —{" "}
      {dayjs(selectedSlot.AvailableTime, "HH:mm:ss").format("hh:mm A")}
    </div>

  </div>

)}

</Modal>

    <Modal
  open={actionModalOpen}
  footer={null}
  title={
    <div className="text-xl font-bold text-slate-800">
      Interview Actions
    </div>
  }
  onCancel={() => setActionModalOpen(false)}
  centered
>

{selectedInterview && (

<div className="flex flex-col gap-4 mt-2">

  {/* JOIN INTERVIEW BUTTON */}
  {selectedInterview.InterviewStatus !== "COMPLETED" && (

    <Button
      type="primary"
      block
      className="h-12 text-base font-semibold text-white transition-all duration-200 border-none shadow-md rounded-xl bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700"
      onClick={() =>
        window.open(selectedInterview.MockInterviewLink, "_blank")
      }
    >
      🚀 Join Mock Interview
    </Button>

  )}

  {/* ADD INTERVIEW LINK */}
  {selectedInterview.InterviewStatus !== "COMPLETED" && (<Button
    type="primary"
    block
    className="h-12 text-base font-semibold text-white transition-all duration-200 border-none shadow-md rounded-xl bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700"
    onClick={() => {
      setActionModalOpen(false);
      setInterviewLinkModalOpen(true);
    }}
  >
    🔗 Add Interview Link
  </Button>)}

  {/* ADD FEEDBACK */}
  <Button
    type="primary"
    block
    className="h-12 text-base font-semibold text-white transition-all duration-200 border-none shadow-md rounded-xl bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700"
    onClick={() => {
      setActionModalOpen(false);
      setFeedbackModalOpenNew(true);
    }}
  >
    📝 Add Feedback
  </Button>

</div>

)}

</Modal>

<Modal
  open={interviewLinkModalOpen}
  title={
    <div className="text-xl font-bold text-slate-800">
      Add Interview Link
    </div>
  }
  footer={null}
  onCancel={() => setInterviewLinkModalOpen(false)}
  centered
>

{selectedInterview && (

<Form layout="vertical" onFinish={updateInterviewLink} className="mt-3">

  {/* INFO CARD */}
  <div className="p-4 mb-4 border shadow-sm bg-slate-50 rounded-xl border-slate-200">
    
    <p className="text-sm text-slate-600">
      Student
    </p>
    <p className="font-semibold text-slate-800">
      {selectedInterview.StudentName}
    </p>

    <p className="mt-2 text-sm text-slate-600">
      Scheduled Date
    </p>
    <p className="font-semibold text-slate-800">
      {dayjs(selectedInterview.ScheduledDate).format("DD MMM YYYY")}
    </p>

  </div>

  {/* LINK INPUT */}
  <Form.Item
    label={<span className="font-semibold text-slate-700">Mock Interview Link</span>}
    name="link"
    rules={[{ required: true, message: "Please enter interview link" }]}
  >
    <Input
      placeholder="https://meet.google.com/..."
      className="rounded-lg h-11 border-slate-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
    />
  </Form.Item>

  {/* SUBMIT BUTTON */}
  <Button
    type="primary"
    htmlType="submit"
    block
    className="h-12 mt-2 text-base font-semibold text-white transition-all duration-200 border-none shadow-md rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700"
  >
    🔗 Update Interview Link
  </Button>

</Form>

)}

</Modal>

<Modal
  open={feedbackModalOpenNew}
  footer={null}
  title={
    <div className="text-xl font-bold text-slate-800">
      Submit Interview Feedback
    </div>
  }
  onCancel={() => setFeedbackModalOpenNew(false)}
  centered
>

<Form layout="vertical" onFinish={submitFeedback} className="mt-3">

  {/* RESULT */}
  <Form.Item
  label={<span className="font-semibold text-slate-700">Result</span>}
  name="result"
  rules={[{ required: true, message: "Please select result" }]}
>
  <Select
    placeholder="Select Result"
    className="h-11"
    options={[
      { value: "PASS", label: "✅ PASS" },
      { value: "FAIL", label: "❌ FAIL" },
    ]}
  />
</Form.Item>

  {/* SCORE */}
  <Form.Item label={<span className="font-semibold text-slate-700">Score</span>} name="score">
    <Input
      type="number"
      placeholder="Enter score out of 100"
      className="rounded-lg h-11 border-slate-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
    />
  </Form.Item>

  {/* HIRING PROBABILITY */}
  <Form.Item
  label={<span className="font-semibold text-slate-700">Hiring Probability</span>}
  name="hiring"
  rules={[{ required: true, message: "Please select hiring probability" }]}
>
  <Select
    placeholder="Select Hiring Decision"
    className="h-11"
  >
    <Select.Option value="WEAK_HIRE">
      <span className="font-semibold text-yellow-500">⚠️ WEAK HIRE</span>
    </Select.Option>

    <Select.Option value="HIRE">
      <span className="font-semibold text-blue-500">👍 HIRE</span>
    </Select.Option>

    <Select.Option value="STRONG_HIRE">
      <span className="font-semibold text-emerald-600">🔥 STRONG HIRE</span>
    </Select.Option>
  </Select>
</Form.Item>

  {/* FEEDBACK */}
  <Form.Item label={<span className="font-semibold text-slate-700">Technical Feedback</span>} name="feedback">
    <Input.TextArea
      rows={4}
      placeholder="Write detailed feedback..."
      className="rounded-lg border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
    />
  </Form.Item>

  {/* SUBMIT BUTTON */}
  <Button
    type="primary"
    htmlType="submit"
    block
    className="h-12 mt-2 text-base font-semibold text-white transition-all duration-200 border-none shadow-md rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700"
  >
    🚀 Submit Feedback
  </Button>

</Form>

</Modal>


<Modal
  title={
    <div className="text-xl font-bold text-slate-800">
      Update Interview Status
    </div>
  }
  open={statusModalOpen}
  onCancel={() => setStatusModalOpen(false)}
  footer={null}
  width={620}
  centered
>

{selectedInterview && (
  <div className="mt-3 space-y-5">

    {/* DETAILS CARD */}
    <div className="grid grid-cols-2 gap-4 p-4 text-sm border shadow-sm rounded-xl bg-slate-50 border-slate-200">

      <div>
        <p className="text-xs text-slate-500">Course</p>
        <p className="font-semibold text-slate-800">{selectedInterview.CourseName}</p>
      </div>

      <div>
        <p className="text-xs text-slate-500">Batch</p>
        <p className="font-semibold text-slate-800">
          {selectedInterview.BatchName} ({selectedInterview.BatchType})
        </p>
      </div>

      <div>
        <p className="text-xs text-slate-500">Student</p>
        <p className="font-semibold text-slate-800">{selectedInterview.StudentName}</p>
      </div>

      <div>
        <p className="text-xs text-slate-500">Email</p>
        <p className="font-semibold break-all text-slate-800">
          {selectedInterview.StudentEmail}
        </p>
      </div>

      <div>
        <p className="text-xs text-slate-500">Date</p>
        <p className="font-semibold text-slate-800">
          {dayjs(selectedInterview.ScheduledDate).format("DD MMM YYYY")}
        </p>
      </div>

      <div>
        <p className="text-xs text-slate-500">Time</p>
        <p className="font-semibold text-slate-800">
          {dayjs(selectedInterview.ScheduledTime, "HH:mm").format("hh:mm A")}
        </p>
      </div>

    </div>

    {/* STATUS SELECT */}
    <div>
      <p className="mb-2 text-sm font-semibold text-slate-700">
        Select Status
      </p>

     <select
  value={newStatus}
  onChange={(e) => setNewStatus(e.target.value)}
  className="w-full px-3 mb-6 border rounded-lg h-11"
>
  <option value="" disabled>
    Select Status
  </option>
  <option value="NO_SHOW">NO_SHOW</option>
</select>
    </div>

    {/* ACTION BUTTON */}
    <Button
      type="primary"
      block
      loading={statusLoading}
      onClick={handleUpdateStatus}
      className="h-12 text-base font-semibold text-white transition-all duration-200 border-none shadow-md rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700"
    >
      ⚡ Update Interview Status
    </Button>

  </div>
)}

</Modal>

    </div>

  );

}

export default MockInterviewInstructor;